module.exports = __webpack_public_path__ + "static/img/s3.f14b507f.jpg";